export const onboardingSteps = [
  'Questionnaire',
  'Payment',
  'Verification',
  'Prescription',
]
